import { Routes, Router } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { TransactionComponent } from './features/transaction/transaction.component';
import { AuthGuard } from './core/guards/auth.gard.service';
import { AuthService } from './core/auth/auth.service';
import { inject } from '@angular/core';
import { FaqComponent } from './features/faq/faq.component';

// Guard to prevent authenticated users from accessing login
const preventAuthenticatedGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  if (authService.LoginStatus) {
    router.navigate(['/transactions']);
    return false;
  }
  return true;
};

export const routes: Routes = [
  { 
    path: '', 
    redirectTo: 'transactions',
    pathMatch: 'full'
  },
  { 
    path: 'login', 
    component: LoginComponent,
    canActivate: [preventAuthenticatedGuard]
  },
  { 
    path: 'transactions', 
    component: TransactionComponent, 
    canActivate: [AuthGuard] 
  },
  { 
    path: 'faqs', 
    component: FaqComponent, 
    canActivate: [AuthGuard] 
  },
  {
    path: 'terms-of-use',
    loadComponent: () => import('./features/terms-of-use/terms-of-use.component').then(m => m.TermsOfUseComponent)
  }
];
